import React from "react";
import types from "./types";

const Template = ({ size, color, variant, ...props }) => (
  <svg
    fill="none"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    {variant === "outline" && (
      <path
        d="M4.40601 14.523L7.80801 11.121L10.636 13.95L13.793 10.793L12 9H17V14L15.207 12.207L10.636 16.778L7.80801 13.95L5.33301 16.424C6.45642 18.1149 8.18063 19.3154 10.1562 19.7823C12.1318 20.2493 14.2111 19.9477 15.9726 18.9387C17.7342 17.9297 19.0462 16.2888 19.6429 14.3484C20.2397 12.4081 20.0764 10.3134 19.1863 8.48893C18.2961 6.66446 16.7456 5.24663 14.8491 4.52274C12.9525 3.79886 10.8516 3.82307 8.97219 4.59047C7.09279 5.35787 5.57541 6.81106 4.72754 8.65556C3.87967 10.5001 3.76473 12.5979 4.40601 14.524V14.523ZM2.86801 16.081L2.85801 16.071L2.86201 16.067C2.29194 14.787 1.99821 13.4012 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C7.93001 22 4.43001 19.57 2.86801 16.081Z"
        fill={color}
      />
    )}

    {variant === "default" && (
      <path
        d="M3.89701 17.86L7.80701 13.95L10.636 16.778L15.207 12.208L17 14V9H12L13.793 10.793L10.636 13.95L7.80801 11.121L2.86201 16.067C2.29194 14.787 1.99821 13.4012 2.00001 12C2.00001 6.477 6.47701 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C10.418 22.001 8.85839 21.6262 7.44962 20.9065C6.04084 20.1867 4.82321 19.1425 3.89701 17.86Z"
        fill={color}
      />
    )}
  </svg>
);

Template.propTypes = types.propTypes;
Template.defaultProps = types.defaultProps;

export default Template;
